import protocol  from "./protocol.js";

/**
 * 默认地址信息
 */
export const WEBDEFAULT = {
  baseUrl: "http://106.75.133.182:8859",
  imgBaseUrl:"http://106.75.133.182:9060/images/",
  name: "外网测试服",
}

/**
 * 烈火官网默认地址信息
 */
export const FIREHERO_WEBURL = "https://faqback.m2time.net";

// /**
//  *人工客服项目
//  */
// export const WEBDEFAULTLIST = {
//   formal:{
//     baseUrl: "https://faqback.m2time.net",
//     imgBaseUrl:"https://faqback.m2time.net/webapp/images/",
//     name: "正式服",
//   },
//   test:{
//     baseUrl: "http://106.75.133.182:8859",
//     imgBaseUrl:"http://106.75.133.182:9060/images/",
//     name: "外网测试服",
//   },
//   debug:{
//     baseUrl: "http://localhost:8859",
//     imgBaseUrl:"http://106.75.133.182:9060/images/",
//     name: "本地调试服",
//   }
// }

// /**
//  *充值选项
//  */
// export const luan1_charge_list = [
//   {
//     iapid:0,
//     iapname:"60钻",
//     pay_diamond:60,
//     money:6
//   }, {
//     iapid:1,
//     iapname:"330钻",
//     pay_diamond:330,
//     money:30
//   },{
//     iapid:2,
//     iapname:"1080钻",
//     pay_diamond:1080,
//     money:98
//   },{
//     iapid:3,
//     iapname:"2280钻",
//     pay_diamond:2280,
//     money:198
//   },{
//     iapid:4,
//     iapname:"5860钻",
//     pay_diamond:5860,
//     money:488
//   },{
//     iapid:5,
//     iapname:"8100钻",
//     pay_diamond:8100,
//     money:648
//   }
// ]

/**
 * 烈火下载跳转
 */
export const FIREHERO_DOWN_URL = {
  fb:"https://www.facebook.com/2021SAGA",
  baha:"https://forum.gamer.com.tw/A.php?bsn=71476",
  ios:"https://app.adjust.com/bz9hfy4",
  gp:"https://app.adjust.com/ey5baxz"
}

/**
 * 烈火官网配置
 */
export const FIREHERO_WEBSITE_CONFIG = {
  //css资源基本路径
  cssBaseUrl:"../../../assets/web-firehero/",
  heroList:[
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-1.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-1.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-1.png",
      },
      heroCvAudio: "hero-cv-1"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-2.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-2.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-2.png",
      },
      heroCvAudio: "hero-cv-2"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-3.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-3.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-3.png",
      },
      heroCvAudio: "hero-cv-3"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-4.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-4.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-4.png",
      },
      heroCvAudio: "hero-cv-4"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-5.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-5.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-5.png",
      },
      heroCvAudio: "hero-cv-5"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-6.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-6.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-6.png",
      },
      heroCvAudio: "hero-cv-6"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-7.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-7.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-7.png",
      },
      heroCvAudio: "hero-cv-7"
    },
    {
      heroBg: {
        type: "common",
        img: "/imgs/hero-8.png",
      },
      heroInfo: {
        type: "lang",
        img: "/imgs/hero-info-8.png",
      },
      heroCv: {
        type: "lang",
        img: "/imgs/hero-cv-8.png",
      },
      heroCvAudio: "hero-cv-8"
    },
  ],
  featureList:[
    {
      img:"/imgs/feature-1.jpg"
    },
    {
      img:"/imgs/feature-2.jpg"
    },  {
      img:"/imgs/feature-3.jpg"
    },  {
      img:"/imgs/feature-4.jpg"
    },  {
      img:"/imgs/feature-5.jpg"
    },
  ]
}






// WEBPACK FOOTER //
// ./src/config/index.js